// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._audio_ad_container {
  height: inherit;
  display: flex;
  align-items: end;
}

.aud_bottom {
  position: sticky;
  height: 40px;
  background-color: black;
  bottom: 0;
  width: 100%;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  position: absolute;
  background: transparent;
}

#myProgressBar {
  width: 100%;
  text-align: center;
  accent-color: #dbcece;
}

.icons {
  text-align: center;
}

.aud_img {
  background: #262626;
  object-fit: contain;
  height: 100%;
  width: 100%;
  position: relative;
  border-radius: 12px;
}

.adu_time {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: auto;
  position: absolute;
  bottom: 13%;
  right: 0;
  background: #222222 0% 0% no-repeat padding-box;
  padding: 10px 6px 8px 10px;
  z-index: 10000000;
}

.aud_transferent {
  position: absolute;
  width: 100%;
  height: 15px;
  bottom: 23px;
  background-color: transparent;
}

.aud_ancer {
  width: 100%;
  height: inherit;
  border-radius: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/AudPlayer/index.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,+CAAA;EACA,0BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AACJ","sourcesContent":["._audio_ad_container {\n    height: inherit;\n    display: flex;\n    align-items: end;\n}\n\n.aud_bottom {\n    position: sticky;\n    height: 40px;\n    background-color: black;\n    bottom: 0;\n    width: 100%;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n    position: absolute;\n    background: transparent;\n}\n\n#myProgressBar {\n    width: 100%;\n    text-align: center;\n    accent-color: #dbcece\n}\n\n.icons {\n    text-align: center;\n}\n\n.aud_img {\n    background: #262626;\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n    position: relative;\n    border-radius: 12px;\n}\n\n.adu_time {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    width: auto;\n    position: absolute;\n    bottom: 13%;\n    right: 0;\n    background: #222222 0% 0% no-repeat padding-box;\n    padding: 10px 6px 8px 10px;\n    z-index: 10000000;\n}\n\n.aud_transferent {\n    position: absolute;\n    width: 100%;\n    height: 15px;\n    bottom: 23px;\n    background-color: transparent;\n}\n\n.aud_ancer {\n    width: 100%;\n    height: inherit;\n    border-radius: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
